import React from 'react';
import { ArrowRight, Award, Users, BookOpen, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { courses } from '../data/mock';
import AdmissionBanner from '../components/AdmissionBanner';

const Home = () => {
  return (
    <div className="min-h-screen overflow-x-hidden">
      {/* Admission Banner */}
      <div className="pt-20">
        <AdmissionBanner />
      </div>

      {/* Hero Section */}
      <section className="hero-section overflow-x-hidden">
        <div className="hero-content px-4 sm:px-6 lg:px-8">
          <div className="inline-flex items-center gap-2 bg-white/40 backdrop-blur-sm rounded-full px-4 py-2 mb-6 sm:mb-8">
            <Award size={16} className="text-[var(--text-primary)]" />
            <span className="font-mono text-[10px] sm:text-xs uppercase tracking-wider text-[var(--text-primary)]">
              Founded by IIT-ian
            </span>
          </div>

          <h1 className="heading-hero mb-5 sm:mb-6 text-4xl sm:text-5xl lg:text-7xl leading-tight text-center">
            Illuminate Your Academic Journey
          </h1>

          <p className="body-large text-[var(--text-secondary)] mb-8 max-w-3xl mx-auto text-center text-base sm:text-lg lg:text-xl leading-7 sm:leading-8 px-2">
            Affordable & Trusted Coaching Centre in Sector 44 Noida for Classes 1–12.
            Focused board preparation, weekly tests, and conceptual clarity – helping
            students achieve better academic results.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full max-w-md sm:max-w-none mx-auto">
            <Link to="/courses" className="btn-primary w-full sm:w-auto text-center">
              Explore Courses
            </Link>
            <Link to="/contact" className="btn-secondary w-full sm:w-auto text-center">
              Book Free Demo
            </Link>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-6 sm:gap-8 mt-12 sm:mt-16 max-w-2xl mx-auto">
            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-[var(--text-primary)] mb-1">
                5+
              </div>
              <div className="text-[11px] sm:text-sm text-[var(--text-secondary)] font-mono uppercase tracking-wider">
                Years of Serving
              </div>
            </div>

            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-[var(--text-primary)] mb-1">
                500+
              </div>
              <div className="text-[11px] sm:text-sm text-[var(--text-secondary)] font-mono uppercase tracking-wider">
                Students Taught
              </div>
            </div>

            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-[var(--text-primary)] mb-1">
                99%
              </div>
              <div className="text-[11px] sm:text-sm text-[var(--text-secondary)] font-mono uppercase tracking-wider">
                Success Rate
              </div>
            </div>

            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-[var(--text-primary)] mb-1">
                100%
              </div>
              <div className="text-[11px] sm:text-sm text-[var(--text-secondary)] font-mono uppercase tracking-wider">
                Satisfaction
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-14 sm:py-16 lg:py-20 bg-[var(--bg-page)]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12">
            <h2 className="heading-1 mb-4 text-3xl sm:text-4xl lg:text-5xl">
              Why Choose The Lighthouse?
            </h2>
            <p className="body-medium text-[var(--text-secondary)] max-w-2xl mx-auto text-sm sm:text-base lg:text-lg leading-7">
              We combine expert teaching with personalized attention to ensure every student succeeds
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-[var(--bg-card)] p-6 rounded-xl shadow-sm hover-lift">
              <div className="w-12 h-12 bg-[var(--accent-purple-200)] rounded-full flex items-center justify-center mb-4">
                <Award size={24} className="text-[var(--accent-purple-400)]" />
              </div>
              <h3 className="heading-3 mb-2">IIT Graduate Faculty</h3>
              <p className="body-small text-[var(--text-secondary)]">
                Learn from experienced educators led by IIT alumni with proven track records
              </p>
            </div>

            <div className="bg-[var(--bg-card)] p-6 rounded-xl shadow-sm hover-lift">
              <div className="w-12 h-12 bg-[var(--accent-blue-200)] rounded-full flex items-center justify-center mb-4">
                <Users size={24} className="text-[var(--accent-blue-400)]" />
              </div>
              <h3 className="heading-3 mb-2">Small Batch Size</h3>
              <p className="body-small text-[var(--text-secondary)]">
                10-15 students per batch ensuring personalized attention for every child
              </p>
            </div>

            <div className="bg-[var(--bg-card)] p-6 rounded-xl shadow-sm hover-lift">
              <div className="w-12 h-12 bg-[var(--accent-orange-200)] rounded-full flex items-center justify-center mb-4">
                <BookOpen size={24} className="text-[var(--accent-orange-400)]" />
              </div>
              <h3 className="heading-3 mb-2">Comprehensive Study Material</h3>
              <p className="body-small text-[var(--text-secondary)]">
                Updated materials, regular tests, and dedicated doubt-solving sessions
              </p>
            </div>

            <div className="bg-[var(--bg-card)] p-6 rounded-xl shadow-sm hover-lift">
              <div className="w-12 h-12 bg-[var(--accent-green-200)] rounded-full flex items-center justify-center mb-4">
                <Clock size={24} className="text-[#6b8f6d]" />
              </div>
              <h3 className="heading-3 mb-2">Flexible Learning</h3>
              <p className="body-small text-[var(--text-secondary)]">
                Offline, online, and home tuition options available across Delhi NCR
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Courses Preview */}
      <section className="py-14 sm:py-16 lg:py-20 bg-[var(--bg-section)]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:justify-between md:items-end gap-4 mb-10 sm:mb-12">
            <div>
              <h2 className="heading-1 mb-4 text-3xl sm:text-4xl lg:text-5xl">Our Programs</h2>
              <p className="body-medium text-[var(--text-secondary)] text-sm sm:text-base lg:text-lg">
                Comprehensive coaching for all grades and streams
              </p>
            </div>

            <Link
              to="/courses"
              className="hidden md:flex items-center gap-2 text-sm font-medium text-[var(--text-primary)] hover:gap-3 transition-all"
            >
              View All Courses
              <ArrowRight size={18} />
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {courses.slice(0, 3).map((course) => (
              <div key={course.id} className={`course-card ${course.color}`}>
                <div className="mb-3">
                  <span className="font-mono text-xs uppercase tracking-wider text-[var(--text-muted)]">
                    {course.grades}
                  </span>
                </div>
                <h3 className="heading-3 mb-3">{course.title}</h3>
                <p className="body-small text-[var(--text-secondary)] mb-4">
                  {course.description}
                </p>
                <div className="mb-4">
                  <div className="flex flex-wrap gap-2">
                    {course.subjects.slice(0, 3).map((subject) => (
                      <span
                        key={subject}
                        className="text-xs px-3 py-1 bg-white/50 rounded-full text-[var(--text-secondary)]"
                      >
                        {subject}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="mt-auto pt-4 border-t border-black/10">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-[var(--text-primary)]">
                      {course.mode.join(' • ')}
                    </span>
                    <ArrowRight size={18} className="text-[var(--text-primary)]" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8 md:hidden">
            <Link to="/courses" className="btn-primary w-full sm:w-auto inline-block text-center">
              View All Courses
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials/Reviews */}
      <section className="py-14 sm:py-16 lg:py-20 bg-[var(--bg-page)]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-12">
            <h2 className="heading-1 mb-4 text-3xl sm:text-4xl lg:text-5xl">Our Happy Students</h2>
            <p className="body-medium text-[var(--text-secondary)] max-w-2xl mx-auto text-sm sm:text-base lg:text-lg leading-7">
              Real reviews from our students and parents on Google & JustDial
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            <div className="bg-[var(--bg-card)] rounded-xl shadow-sm overflow-hidden hover-lift">
              <img
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/rrrdo32r_REVIEWS1.jpeg"
                alt="Google Review 1"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="bg-[var(--bg-card)] rounded-xl shadow-sm overflow-hidden hover-lift">
              <img
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/p883afml_REVIEWS2.jpeg"
                alt="Google Review 2"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="bg-[var(--bg-card)] rounded-xl shadow-sm overflow-hidden hover-lift">
              <img
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/kgz7vkv0_REVIEWS3.jpeg"
                alt="Google Review 3"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="bg-[var(--bg-card)] rounded-xl shadow-sm overflow-hidden hover-lift">
              <img
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/e9kjhk7e_REVIEWS4.jpeg"
                alt="Google Review 4"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="bg-[var(--bg-card)] rounded-xl shadow-sm overflow-hidden hover-lift">
              <img
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/3cbjyz1p_REVIEWS5.jpeg"
                alt="Google Review 5"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="bg-[var(--bg-card)] rounded-xl shadow-sm overflow-hidden hover-lift">
              <img
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/10lsdedx_REVIEWS6.jpeg"
                alt="Google Review 6"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="bg-[var(--bg-card)] rounded-xl shadow-sm overflow-hidden hover-lift">
              <img
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/83klvgtr_JDREVIEW1.jpeg"
                alt="JustDial Review 1"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="bg-[var(--bg-card)] rounded-xl shadow-sm overflow-hidden hover-lift">
              <img
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/lqktew61_JDREVIEW2.jpeg"
                alt="JustDial Review 2"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="bg-[var(--bg-card)] rounded-xl shadow-sm overflow-hidden hover-lift">
              <img
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/5c4s3892_JD%20REVIEW3.jpeg"
                alt="JustDial Review 3"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="bg-[var(--bg-card)] rounded-xl shadow-sm overflow-hidden hover-lift">
              <img
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/rfabje32_JDREVIEW4.jpeg"
                alt="JustDial Review 4"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="bg-[var(--bg-card)] rounded-xl shadow-sm overflow-hidden hover-lift">
              <img
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/np2km9ne_JDREVIEW5.jpeg"
                alt="JustDial Review 5"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="bg-[var(--bg-card)] rounded-xl shadow-sm overflow-hidden hover-lift">
              <img
                src="https://customer-assets.emergentagent.com/job_lighthouse-coaching/artifacts/xz3ekuy9_JDREVIEW6.jpeg"
                alt="JustDial Review 6"
                className="w-full h-auto object-cover"
              />
            </div>

            <div className="bg-[var(--accent-purple-200)] rounded-xl shadow-sm p-8 flex flex-col items-center justify-center text-center hover-lift sm:col-span-1">
              <div className="text-4xl sm:text-5xl font-bold text-[var(--text-primary)] mb-2">⭐ 4.9</div>
              <p className="text-lg font-semibold text-[var(--text-primary)] mb-2">Rated on Google</p>
              <p className="body-small text-[var(--text-secondary)]">Based on 100+ reviews</p>
            </div>

            <div className="bg-[var(--accent-blue-200)] rounded-xl shadow-sm p-8 flex flex-col items-center justify-center text-center hover-lift sm:col-span-1">
              <div className="text-4xl sm:text-5xl font-bold text-[var(--text-primary)] mb-2">⭐ 5.0</div>
              <p className="text-lg font-semibold text-[var(--text-primary)] mb-2">Rated on JustDial</p>
              <p className="body-small text-[var(--text-secondary)]">Verified customer reviews</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-14 sm:py-16 lg:py-20 bg-[var(--gradient-hero-subtle)]">
        <div className="container mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="heading-1 mb-4 text-3xl sm:text-4xl lg:text-5xl">
            Ready to Excel in Your Studies?
          </h2>
          <p className="body-large text-[var(--text-secondary)] mb-8 max-w-2xl mx-auto text-base sm:text-lg lg:text-xl leading-7 sm:leading-8">
            Join hundreds of successful students at The Lighthouse Coaching Institute
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full max-w-md sm:max-w-none mx-auto">
            <Link to="/contact" className="btn-primary w-full sm:w-auto text-center">
              Enroll Now
            </Link>
            <a
              href="tel:+917004929531"
              className="btn-secondary w-full sm:w-auto text-center"
            >
              Call: +91 70049 29531
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
